//
import { ColumnDef } from "@tanstack/react-table"
// import { TransferProps } from "./resources/user.type"
import moment from "moment"
//
import { ChipStyled } from "src/shared/components"
import { capitalizeFirstLetter } from "src/shared/utils/data-helpers"
import { IconButton, Tooltip } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import { getDisplayPrice } from "src/shared/utils/helpers-functions"
import { PlatformFeeOrderType } from "../../types"
import { PlatformFeeType } from "src/graphql/quark/quark.type"

export const getPlatformFeeListTableColumns = ({
  onEdit,
  hasPermission
}: {
  onEdit?: (platformFee: any) => void
  hasPermission: (permission: string) => boolean
}): ColumnDef<any, any>[] => {
  return [
    // {
    //   header: "ID",
    //   accessorKey: "id",
    // },
    {
      header: "Name",
      accessorKey: "name"
    },
    {
      header: "Order Type",
      accessorKey: "orderType",
      cell: ({ row }) => (
        <ChipStyled
          label={capitalizeFirstLetter(row.original.orderType ?? "")}
          size="small"
          variant="filled"
          color={(getOrderTypeColor(row.original.orderType) as any) ?? "default"}
        />
      )
    },
    {
      header: "Fee Type",
      accessorKey: "platformFeeType",
      cell: ({ row }) => (
        <ChipStyled
          label={capitalizeFirstLetter(row.original.platformFeeType ?? "")}
          size="small"
          variant="filled"
          color={(getFeeTypeColor(row.original.platformFeeType) as any) ?? "default"}
        />
      )
    },
    {
      header: "Fee Value",
      accessorKey: "platformFeeValue",
      cell: ({ row }) => `${getDisplayPrice(row?.original?.platformFeeValue ?? 0)}`
    },
    {
      header: "Tax Rate",
      accessorKey: "platformFeeTaxRate",
      cell: ({ row }) => `${row.original.platformFeeTaxRate || 0}%`
    },
    {
      header: "Taxable",
      accessorKey: "platformFeeTaxable",
      cell: ({ row }) => (
        <ChipStyled
          label={row.original.platformFeeTaxable ? "Yes" : "No"}
          size="small"
          variant="filled"
          color={row.original.platformFeeTaxable ? "success" : "default"}
        />
      )
    },
    {
      header: "Account Code",
      accessorKey: "platformFeeAccountCode"
    },
    {
      header: "Created At",
      accessorKey: "createdAt",
      accessorFn: (row) => moment(row?.createdAt).format("lll")
    },
    {
      header: "Actions",
      enableHiding: false,
      meta: {
        textAlign: "center",
        headerAlign: "center",
        width: "100px"
      },
      cell: ({ row }) => (
        <Tooltip
          title={hasPermission("system:platform-fee:update") ? "Edit Platform Fee" : "You don't have permission"}
        >
          <IconButton
            disabled={!hasPermission("system:platform-fee:update")}
            onClick={() => onEdit?.(row.original)}
            size="small"
            sx={{
              color: "primary.main",
              "&:hover": {
                backgroundColor: "primary.light",
                color: "white"
              }
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )
    }
  ]
}

const getOrderTypeColor = (orderType?: string) => {
  switch (orderType) {
    case PlatformFeeOrderType.Delivery:
      return "primary"
    case PlatformFeeOrderType.Pickup:
      return "success"
    case PlatformFeeOrderType.Return:
      return "secondary"
    default:
      return "default"
  }
}

const getFeeTypeColor = (feeType?: string) => {
  switch (feeType) {
    case PlatformFeeType.Percentage:
      return "primary"
    case PlatformFeeType.Flat:
      return "success"
    default:
      return "default"
  }
}
